import { startTiming } from './utils';

export default function overrideNavigation() {
  const originalNavigateTo = uni.navigateTo;
  // const originalNavigateBack = uni.navigateBack;
  const originalSwitchTab = uni.switchTab;
  const originalReLaunch = uni.reLaunch;
  const originalRedirectTo = uni.redirectTo;

  const wrapNavigationMethod = (method, originalMethod) => {
    return (options) => {
      startTiming(options.url);
      originalMethod.call(uni, options);
    };
  };

  uni.navigateTo = wrapNavigationMethod('navigateTo', originalNavigateTo);
  // uni.navigateBack = wrapNavigationMethod('navigateBack', originalNavigateBack);
  uni.switchTab = wrapNavigationMethod('switchTab', originalSwitchTab);
  uni.reLaunch = wrapNavigationMethod('reLaunch', originalReLaunch);
  uni.redirectTo = wrapNavigationMethod('redirectTo', originalRedirectTo);
}
